import React from "react";

import ApexChart from "./ApexChart";

const ChartWrapper = ({ chartConfig, seriesData = [], themeConfig }) => {
  let body = null;
  if (!seriesData) {
    body = (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          minHeight: "200px"
        }}
      >
        <div>Loading</div>
      </div>
    );
  } else if (chartConfig.chart_type === "table") {
    body = (
      //   <ChartTable marginFlag={marginFlag} chartConfig={chartConfig} seriesData={seriesData} chartValues={chartValues} />
      <></>
    );
  } else {
    body = <ApexChart chartConfig={chartConfig} seriesData={seriesData} chartTheme={themeConfig} />;
  }

  return body;
};

export default ChartWrapper;
